<div class="layout-topbar">
  <a class="layout-topbar-logo" routerLink="">
    <img alt="logo" src="../../../../assets/img/hello-sitter-logo.png" height="198" width="50">
    <span style="font-size: 2rem !important;"> Hello Sitter Admin</span>
  </a>

  <a (click)="app.toggleMenu($event)" class="p-link layout-menu-button layout-topbar-button" href="#">
    <i class="pi pi-bars"></i>
  </a>

  <a (click)="app.toggleTopMenu($event)" class="p-link layout-topbar-menu-button layout-topbar-button" href="#">
    <i class="pi pi-ellipsis-v"></i>
  </a>

  <div class="layout-topbar-menu">
    <a (click)="logout()" class="p-link layout-topbar-button">
      <i class="pi pi-sign-out"></i>
      <span>Log out</span>
    </a>
  </div>
</div>
